export default {
  titulo: '',
  itens: [],
  motivos: [],
  item: {},
  produtoSilenciadoQtde: 0
};
